import 'regenerator-runtime/runtime'
import useBSSLogger from '../hooks/useBSSLogger';
import getapiclient, { getwpclient } from '../lib/ajaxhelper';

const {logger} = useBSSLogger();

const retrieveNazioni = async () => {
    const {data} = await getapiclient().post("tnazioni/grid", {
        take: 9999,
        skip: 0,
        page: 1,
        pageSize: 9999,        
    }) 

    const nazioni = data?.results ?? [];

    logger.debug("ottenute nazioni", nazioni)
    return nazioni; 
}

export {retrieveNazioni}
